/* eslint-disable jsx-a11y/click-events-have-key-events */
/** @jsx jsx */
import React from 'react';
import { css, jsx } from '@emotion/core';
import { Row, Col } from 'react-grid-system';
import BlockUI from 'components/molecules/BlockUi';
import FormContents from 'components/atoms/Form/FormContents';
import FormTitle from 'components/atoms/Form/FormTitle';
import TableAgreement36 from './TableAgreement36';
import useAttendAgreement36 from './hooks';
import useAchievementErrorState from 'components/pages/master/attendanceRecord/hook';
import CalendarForm from 'components/molecules/CalendarForm';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FlexBox from 'components/atoms/FlexBox';
import FormPadding from 'components/atoms/Form/FormPadding';
import FormLabel from 'components/atoms/Form/FormLabel';
import Icon from 'components/atoms/Icon';
import BodyText from "components/atoms/BodyText";
import productColor from 'components/styles';
import { Link } from 'react-router-dom';
import Table from 'components/molecules/Table';
import SelectForm from "components/molecules/SelectForm";
import FormHeader from 'components/templates/FormHeader';
// import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import ClickableIconButton from 'components/atoms/ClickableIconButton';
import moment from 'moment';
import CalendarMonth from 'components/molecules/CalendarV1/CalendarMonth';

const styles = {
  title: css({
    fontSize: "18px",
    color: "#333333",
    fontWeight: 700,
    marginLeft: '0'
  }),
  errText: css({
    color: productColor.deleteAction,
    textDecoration: 'underline',
    fontSize: '14px'
  }),
  alertLabel: css({
    margin: '0 15px'
  }),
  tableContainer: css({
    padding: '15px 15px',
    width: 'calc( 50% - 70px )',
    alignSelf: 'flex-start'
  }),
  tableContent: css`
    td{
      :last-child{
        color: ${productColor.primary}
      }
      text-align: center
    }
  `,
  titleTable: css({
    fontWeight: 'bold'
  }),
  errorNote: css({
    color: productColor.secondary
  }),
  warningNote: css({
    color: productColor.copyAction
  })
};

const AttendAgreement36: React.FC = () => {
  // current day
  const dayOfWeekAsString = (dayIndex: number) => {
    return ['日', '月', '火', '水', '木', '金', '土'][dayIndex];
  };

  const getStyleLabel = (index: number, lengthList: number) => {
    switch (index) {
      case lengthList - 2:
        return styles.warningNote;
      case lengthList - 1:
        return styles.errorNote;
      default:
        return {};
    };
  };

  const {
    isLoading,
    tableAgreement36Data,
    applyDate,
    setApplyDate,
    alertAgreement36Data,
    staffCode,
    orgCode,
    setOrgCode,
    orgTreesOptions,
    myAlertAgreement36Data,
    dateFrom,
    dateTo,
  } = useAttendAgreement36();

  const {errorList} = useAchievementErrorState();


  return (
    <BlockUI blocking={isLoading}>
      <FormHeader title="ホーム" />
      <FormContents customStyle={css({ marginTop:'60px'})}>
        <FormPadding>
          <FlexBox customStyle={css({margin: '7px 0'})}>        
            <FormLabel 
              label="営業月" 
              customStyle={css({ width: '100px', margin: '0' })} 
            />
            <FlexBoxItem>
              <CalendarMonth 
                openActionChevron={true}
                date={applyDate}
                setDate={(date: Date) => {
                  if (date.getMonth() !== applyDate.getMonth() || date.getFullYear() !== applyDate.getFullYear()) {
                    setApplyDate(date);
                    sessionStorage.setItem('agreement36.applyTargetDate', moment(date).format("YYYY/MM/DD"));
                  }
                }}
              />
            </FlexBoxItem>
            {/* <FlexBoxItem>
              <ClickableIconButton onClick={() => {
                setApplyDate(new Date(moment(applyDate).subtract(1, 'month').format('YYYY/MM/01')));
                sessionStorage.setItem('agreement36.applyTargetDate', moment(applyDate).subtract(1, 'month').format("YYYY/MM/DD"));
              }} additionalCss={css({ marginLeft: '-35px' })}>
                <Icon type="chevronLeft" color="" size="24px" />
              </ClickableIconButton>
            </FlexBoxItem>

            <FlexBoxItem width="160px">
              <CalendarForm
                required={true}
                label=""
                date={applyDate}
                dateFormat="YYYY/MM"
                changeDate={(date: Date) => {
                  if (date.getMonth() !== applyDate.getMonth() || date.getFullYear() !== applyDate.getFullYear()) {
                    setApplyDate(date);
                    sessionStorage.setItem('agreement36.applyTargetDate', moment(date).format("YYYY/MM/DD"));
                  }
                }} 
              />
            </FlexBoxItem>

            <FlexBoxItem>
              <ClickableIconButton 
                onClick={() => {
                  setApplyDate(new Date(moment(applyDate).add(1, 'month').format('YYYY/MM/01')));
                  sessionStorage.setItem(
                    'agreement36.applyTargetDate', 
                    moment(applyDate).add(1, 'month').format("YYYY/MM/DD")
                  );
                }}
              >
                <Icon 
                  type="chevronRight" 
                  color="" 
                  size="24px" 
                />
              </ClickableIconButton>
            </FlexBoxItem> */}
          </FlexBox>
         
          <div>
            {
              alertAgreement36Data && alertAgreement36Data.errorCount > 0 && (
                <FlexBox>
                  <Icon 
                    type="error" 
                    color={'red'} 
                    margin='0 0 4px 0' 
                  />
                  <BodyText customStyle={styles.alertLabel}>
                    打刻エラー
                  </BodyText>
                  <Link 
                    to="/attendError" 
                    css={styles.errText}
                    onClick={() => {
                      sessionStorage.setItem('attendError.staffCode', staffCode);
                      sessionStorage.setItem('attendError.isFilter', 'true');
                      sessionStorage.setItem('attendError.targetDateFrom', dateFrom);
                      sessionStorage.setItem('attendError.targetDateTo', dateTo);
                    }}
                  >
                    {alertAgreement36Data.errorCount}件
                  </Link>
                </FlexBox>
              )
            }
            {
              alertAgreement36Data && alertAgreement36Data.approvalCount > 0 && alertAgreement36Data.isApproval === 1 && (
                <FlexBox>
                  <Icon 
                    type="error" 
                    color={'red'} 
                    margin='0 0 4px 0' 
                  />
                  <BodyText customStyle={styles.alertLabel}>
                    未承認の勤怠申請
                  </BodyText>
                  <Link 
                    to="/attendApplicationApproval" 
                    css={styles.errText}
                    onClick={() => {
                      sessionStorage.setItem('attendApplicationApproval.targetDateFrom', dateFrom);
                      sessionStorage.setItem('attendApplicationApproval.targetDateTo', dateTo);
                    }}
                  >
                    {alertAgreement36Data.approvalCount}件
                  </Link>
                </FlexBox>
              )
            }
            {
              alertAgreement36Data && alertAgreement36Data.alertCount > 0 && (
                <FlexBox>
                  <Icon 
                    type="error" 
                    color={'red'} 
                    margin='0 0 4px 0' 
                  />
                  <BodyText customStyle={styles.alertLabel}>
                    その他アラート
                  </BodyText>
                  <Link 
                    to="/attendError" 
                    css={styles.errText}
                    onClick={() => {
                      sessionStorage.setItem('attendError.staffCode', staffCode);
                      sessionStorage.setItem('attendError.isFilter', 'false');
                      sessionStorage.setItem('attendError.targetDateFrom', dateFrom);
                      sessionStorage.setItem('attendError.targetDateTo', dateTo);
                    }}
                  >
                    {alertAgreement36Data.alertCount}件
                  </Link>
                </FlexBox>
              )
            }            
          </div>
        </FormPadding>

        {
          tableAgreement36Data && (
            <TableAgreement36
              tableAgreement36Data={tableAgreement36Data}
            />
          )
        }

        {
          myAlertAgreement36Data && (
            <React.Fragment>
              <FormTitle 
                title="年次勤怠アラート" 
                bold={true} 
                customStyle={css({marginLeft: '15px', marginRight: '30px', padding: '0px'})}
              />
              <Row>
                <Col xl={6} md={12} xs={12} >
                  <FlexBox customStyle={css({marginLeft: '15px', marginTop: '20px'})}>
                    <FlexBoxItem width="70px">
                      <FormLabel label="組織"/>
                    </FlexBoxItem>          
                    <FlexBoxItem 
                      grow={1} 
                      width="150px" 
                      customStyle={css({marginRight: '30px'})}
                    >
                      <SelectForm
                        label=""
                        name="orgCode"
                        value={String(orgCode)}
                        setValue={(v) => {setOrgCode(v);}}
                        options={orgTreesOptions}
                        description=""
                        ghost={(['3', '2'].indexOf(sessionStorage.getItem('loginUser.site') || "") === -1 && orgTreesOptions.length === 1)}
                      />
                    </FlexBoxItem>
                  </FlexBox>
                </Col>
              </Row>
              <React.Fragment>
                <FlexBox customStyle={css({flexWrap: 'wrap', marginRight: '-80px'})}>
                  {/* Table 1 */}
                  <FlexBoxItem customStyle={styles.tableContainer}>            
                    <FormLabel label="年間の法定時間外残業" customStyle={styles.titleTable}/>
                    <Table customStyle={styles.tableContent}>
                      <thead>
                        <tr>
                          <Table.HeaderCell>
                            アラート内容
                          </Table.HeaderCell>
                            <Table.HeaderCell>
                              件数
                          </Table.HeaderCell>
                          </tr>
                        </thead>
                        <tbody>
                          {myAlertAgreement36Data?.overtimeAlertCntAry?.map((item, index) => (
                            <tr>
                              <Table.Cell css={getStyleLabel(index, myAlertAgreement36Data?.overtimeAlertCntAry.length)}>
                                {item[0]}時間を超過
                              </Table.Cell>
                              <Table.Cell>{item[1]}件</Table.Cell>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </FlexBoxItem>

                    {/* Table 2 */}
                    <FlexBoxItem customStyle={styles.tableContainer}>
                      <FormLabel label="複数月の平均残業時間" customStyle={styles.titleTable} />
                      <Table customStyle={styles.tableContent}>
                        <thead>
                          <tr>
                            <Table.HeaderCell>
                              アラート内容
                          </Table.HeaderCell>
                            <Table.HeaderCell>
                              件数
                          </Table.HeaderCell>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <Table.Cell css={styles.errorNote}>
                              {myAlertAgreement36Data?.agreementsMst.averageOvertimeHour}時間を超過
                            </Table.Cell>
                            <Table.Cell>
                              {myAlertAgreement36Data?.aveOverAlertCnt}件
                            </Table.Cell>
                          </tr>
                        </tbody>
                      </Table>
                    </FlexBoxItem>

                    {/* Table 3 */}
                    <FlexBoxItem customStyle={styles.tableContainer}>
                      <FormLabel 
                        label={`法定時間外労働${myAlertAgreement36Data?.agreementsMst.monthOverConditionsHour}時間超過申請`} 
                        customStyle={styles.titleTable} 
                      />
                      <Table customStyle={styles.tableContent}>
                        <thead>
                          <tr>
                            <Table.HeaderCell>
                              アラート内容
                          </Table.HeaderCell>
                            <Table.HeaderCell>
                              件数
                          </Table.HeaderCell>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            myAlertAgreement36Data?.overConditionsAlertCntAry?.map((item, index) => (
                              <tr>
                                <Table.Cell css={getStyleLabel(index, myAlertAgreement36Data?.overConditionsAlertCntAry.length)}>
                                  {item[0]}回超過
                                </Table.Cell>
                                <Table.Cell>{item[1]}件</Table.Cell>
                              </tr>
                            ))
                          }
                        </tbody>
                      </Table>
                    </FlexBoxItem>

                    {/* Table 4 */}
                    <FlexBoxItem customStyle={styles.tableContainer}>
                      <FormLabel 
                        label="法定時間外労働と休日出勤の合計" 
                        customStyle={styles.titleTable} 
                      />
                      <Table customStyle={styles.tableContent}>
                        <thead>
                          <tr>
                            <Table.HeaderCell>
                              アラート内容
                          </Table.HeaderCell>
                            <Table.HeaderCell>
                              件数
                          </Table.HeaderCell>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <Table.Cell css={styles.errorNote}>
                              {myAlertAgreement36Data.agreementsMst.monthlyOverAndHolidayTimeHour || 0}時間を超過
                            </Table.Cell>
                            <Table.Cell>
                              {myAlertAgreement36Data.overHolidayTimeAlertCnt || 0}件
                            </Table.Cell>
                          </tr>
                        </tbody>
                      </Table>
                    </FlexBoxItem>
                </FlexBox>
              </React.Fragment>
            </React.Fragment>
          )
        }
      </FormContents>
    </BlockUI>
  );
};

export default AttendAgreement36;
